import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=139cdb0c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('139cdb0c')) {
      api.createRecord('139cdb0c', component.options)
    } else {
      api.reload('139cdb0c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=139cdb0c&", function () {
      api.rerender('139cdb0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ectbygNkngya/JS/comp/ImgFallback.vue"
export default component.exports